// extracted by mini-css-extract-plugin
export default {"root":"ExpertKnowledgeDetails_root__lM870","filter":"ExpertKnowledgeDetails_filter__O+D1X"};